import { build_wechat, build_h5 } from "@/helper/types/build";
import Axios from "axios";
import config from "@/config/config";
let apiList = [
    "chooseWXPay",
    "updateTimelineShareData",
    "updateAppMessageShareData",
];
let initWxSdk = () => {};
if (config.BUILD_TYPE == build_wechat) {
    const wx = require("weixin-js-sdk");
    initWxSdk = (route = "", cb) => {
        let authorizationUrl = `${config.WEB_DOMAIN_NAME}${route ? route : ""}`;
        Axios.get(`${config.API_BASE_URL}client/config/wechat`, {
            params: {
                url: window.encodeURIComponent(authorizationUrl),
            },
        }).then((res) => {
            let { appId, timeStamp, nonceStr, paySign } = res.data.data || {};
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: appId || "", // 必填，公众号的唯一标识
                timestamp: timeStamp || "", // 必填，生成签名的时间戳
                nonceStr: nonceStr || "", // 必填，生成签名的随机串
                signature: paySign || "", // 必填，签名
                jsApiList: apiList, // 必填，需要使用的JS接口列表
            });
            cb && cb(wx);
        });
    };
}
export default initWxSdk;
